/**
 * Main App Component
 * 
 * Root component with routing configuration
 */

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import AuthCallback from './pages/AuthCallback';
import HomePage from './pages/HomePage.jsx';
import DashboardPage from './pages/DashboardPage';
import CompetitionListPage from './pages/CompetitionListPage';
import CompetitionDetailPage from './pages/CompetitionDetailPage';
import CompetitionSubmissionsPage from './pages/CompetitionSubmissionsPage';
import ReelViewerPage from './pages/ReelViewerPage';
import CreateCompetitionPage from './pages/CreateCompetitionPage';
import AdminRolesPage from './pages/AdminRolesPage';
import favicon from './assets/images/favicon.ico';
import './App.css';

function App() {
  useEffect(() => {
    const iconLinks = document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']");

    iconLinks.forEach((link) => {
      link.setAttribute('href', favicon);
    });
  }, []);

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-and-conditions" element={<TermsConditionsPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            <Route
              path="/"
              element={<HomePage />}
            />

            {/* Protected routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />

            {/* Competition routes */}
            <Route
              path="/competitions"
              element={<CompetitionListPage />}
            />
            <Route
              path="/competitions/:id"
              element={<CompetitionDetailPage />}
            />
            <Route
              path="/competitions/:id/submissions"
              element={<CompetitionSubmissionsPage />}
            />
            <Route
              path="/reels"
              element={<ReelViewerPage />}
            />
            <Route
              path="/reels/:competitionId"
              element={<ReelViewerPage />}
            />
            <Route
              path="/competitions/new"
              element={
                <ProtectedRoute>
                  <CreateCompetitionPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/competitions/:id/edit"
              element={
                <ProtectedRoute>
                  <CreateCompetitionPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/roles"
              element={
                <ProtectedRoute>
                  <AdminRolesPage />
                </ProtectedRoute>
              }
            />

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
